import React, { useState } from 'react'
import { Select } from 'antd'
import './index.module.less'

const { Option } = Select

const TypesSelect = ({ onChange, types }) => {
  const [currentParent, setParent] = useState(null)
  const [currentType, setType] = useState(null)
  const onChangeParent = (parent) => {
    setParent(parent)
    setType(null)
    if (onChange) {
      onChange(currentType, parent)
    }
  }

  const onChangeChildren = (type) => {
    setType(type)
    if (onChange) {
      onChange(type, currentParent)
    }
  }

  let children
  const currentTypeData = types.filter((type) => type.id === currentParent)[0]
  if (currentTypeData) {
    children = currentTypeData.children
  } else {
    children = []
  }

  return (
    <div styleName="types-select">
      <div styleName="types-select-item">
        <Select placeholder="请选择漏洞类型" onChange={onChangeParent}>
          {types.map((type) => (
            <Option value={type.id} key={type.id}>
              {type.name}
            </Option>
          ))}
        </Select>
      </div>
      <div styleName="types-select-item">
        <Select
          placeholder="请选择漏洞类型"
          onChange={onChangeChildren}
          value={currentType}
        >
          {children.map((item) => (
            <Option value={item.id} key={item.id}>
              {item.name}
            </Option>
          ))}
        </Select>
      </div>
    </div>
  )
}

export default TypesSelect
